function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.208 90 H 8.792 C 3.936 90 0 86.064 0 81.208 V 8.792 C 0 3.936 3.936 0 8.792 0 h 72.417 C 86.064 0 90 3.936 90 8.792 v 72.417 C 90 86.064 86.064 90 81.208 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.554 42.626 c -0.28 -0.134 -0.564 -0.263 -0.852 -0.387 c -0.502 -9.245 -5.553 -14.537 -14.035 -14.591 c -0.038 0 -0.077 0 -0.115 0 c -5.073 0 -9.293 2.166 -11.89 6.106 l 4.665 3.2 c 1.94 -2.943 4.985 -3.571 7.227 -3.571 c 0.026 0 0.052 0 0.078 0 c 2.793 0.018 4.9 0.83 6.264 2.413 c 0.993 1.153 1.656 2.746 1.985 4.756 c -2.476 -0.421 -5.154 -0.55 -8.017 -0.386 c -8.064 0.465 -13.248 5.168 -12.9 11.703 c 0.177 3.315 1.828 6.167 4.65 8.03 c 2.386 1.575 5.459 2.345 8.652 2.171 c 4.217 -0.231 7.526 -1.84 9.834 -4.783 c 1.753 -2.234 2.862 -5.13 3.351 -8.778 c 2.01 1.213 3.5 2.809 4.322 4.728 c 1.399 3.262 1.48 8.622 -2.893 12.992 c -3.832 3.828 -8.438 5.484 -15.399 5.535 c -7.722 -0.057 -13.562 -2.534 -17.359 -7.361 c -3.556 -4.52 -5.393 -11.048 -5.462 -19.404 c 0.069 -8.356 1.906 -14.884 5.462 -19.404 c 3.797 -4.827 9.637 -7.303 17.359 -7.361 c 7.778 0.058 13.72 2.546 17.662 7.396 c 1.933 2.378 3.39 5.37 4.351 8.857 l 5.466 -1.458 c -1.165 -4.293 -2.997 -7.992 -5.491 -11.06 c -5.054 -6.218 -12.446 -9.404 -21.97 -9.47 h -0.038 c -9.505 0.066 -16.814 3.264 -21.724 9.506 c -4.369 5.554 -6.623 13.283 -6.699 22.971 l 0 0.023 l 0 0.023 c 0.076 9.688 2.33 17.417 6.699 22.971 c 4.91 6.242 12.219 9.44 21.724 9.506 H 45.5 c 8.45 -0.059 14.406 -2.271 19.313 -7.173 c 6.42 -6.414 6.226 -14.453 4.111 -19.388 C 67.406 47.399 64.512 44.525 60.554 42.626 z M 45.964 56.344 c -3.534 0.199 -7.206 -1.387 -7.387 -4.785 c -0.134 -2.519 1.793 -5.331 7.604 -5.666 c 0.666 -0.038 1.319 -0.057 1.96 -0.057 c 2.111 0 4.086 0.205 5.881 0.598 C 53.353 54.796 49.425 56.154 45.964 56.344 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsLogo);
export default __webpack_public_path__ + "static/media/threads-logo.7f15157634aa8ddc6a77970a3f9434d4.svg";
export { ForwardRef as ReactComponent };